import { Seasons } from '../core/constants.js';

const seasonKeyMap = {
  Digit1: Seasons.SPRING,
  Digit2: Seasons.SUMMER,
  Digit3: Seasons.AUTUMN,
  Digit4: Seasons.WINTER
};

export class KeyboardController {
  constructor({ onAction }) {
    this.onAction = onAction;
    this.onKeyDown = this.onKeyDown.bind(this);
    window.addEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(event) {
    if (event.repeat) {
      return;
    }

    if (seasonKeyMap[event.code]) {
      this.onAction({
        type: 'SEASON_KEY',
        season: seasonKeyMap[event.code]
      });
      return;
    }

    if (event.code === 'Space') {
      event.preventDefault();
      this.onAction({ type: 'TOGGLE_STATE' });
      return;
    }

    if (event.code === 'Escape') {
      this.onAction({ type: 'EXIT_FOCUS' });
    }
  }

  dispose() {
    window.removeEventListener('keydown', this.onKeyDown);
  }
}
